import { KEEPR_CURRENCY } from '../config/preferenceDefs';
import { getCurrency } from './currency';
import { collectionCurrencyCode } from './collectionCurrency';

/**
 * The currency NEW money starts in (docs/plans/localization-preferences.md
 * §4, the owner's ruling L3) — the web half of keepr-api
 * utils/newMoneyCurrency.js, in the same order:
 *
 *   1. the collection's currency (its own, else the nearest collection above
 *      that sets one — `currencyResolved.code`), when the element belongs to
 *      a collection. A collection that sets one is never steered by whoever
 *      is editing it;
 *   2. else the author's `currency` preference;
 *   3. else US dollars.
 *
 * `collection` is the loaded collection document (null for a global card or
 * set, or while it loads); `prefs` the person's preferences.
 */
export function newMoneyCurrency({ collection = null, prefs = null } = {}) {
	const fromCollection = collectionCurrencyCode(collection);
	if (fromCollection) return fromCollection;
	const preferred = typeof prefs?.currency === 'string' ? prefs.currency : '';
	if (preferred && getCurrency(preferred)) return preferred;
	return KEEPR_CURRENCY;
}
